module.exports = __webpack_public_path__ + "img/brand-28.dc4daf35.png";